import nlp from 'compromise';
import { slice, uniq } from 'lodash';

const style = {
    removecommentedtext: {
        name: "Remove commented text",
        description: "Removes the commented text that are specified by % symbol.",
        action: (data, filename) => {
            // data = data.replace(/(?<!\\)%[^\n]*/gms, "")
            data = data.replace(/[ \t]*(?<!\\)%[^\n]*(?:\r?\n)?/g, "");
            return data;
        },
    },
    separateAuthor: {
        name: "Separate Author",
        description: "Author separated with comma and insert and before last author.",
        action: (data, filename) => {
            const author = new RegExp(/\\author(\[\w+\])?\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/gm);
            if (/\\author(\[\w+\])?\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/gm.test(data)) {
                let res;
                while ((res = author.exec(data)) !== null) {
                    if (res) {
                        console.log(res);
                        if (res[0].includes(",")) {
                            let authors = res[2].split(",");
                            let text =
                                authors.length > 1
                                    ? authors.slice(0, -1).join(",") + " and " + authors[authors.length - 1].trim()
                                    : authors[0] || "";
                            data = data.replace(res[0], `\\author{${text}}`)
                            return data
                        }

                    }
                }
            }
        },
    },
    nameCapatilize: {
        name: "Capatilize Names",
        description: "Capatilize each words of the author",
        action: (data, fileName) => {
            const author = new RegExp(/\\author(\[\w+\])?\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/gm);
            if (/\\author(\[\w+\])?\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/gm.test(data)) {
                let res;
                while ((res = author.exec(data)) !== null) {
                    if (res) {
                        let authors = res[res.length - 1]
                        console.log(authors);
                        let text = authors.split(" ").map((w) => w.charAt(0).toUpperCase() + (w.slice(1))).join(" ");
                        data = data.replace(res[res.length - 1], text)
                        return data
                    }
                }
            }
        }
    },
    removehonorifics: {
        name: "Remove honorifics",
        description: "Remove honorifics from the author name.",
        action: (data, fileName) => {
            const author = new RegExp(/\\author(\[\w+\])?\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/gm);
            const honorifics = new Set([
                // Common English
                "mr", "mister", "mrs", "miss", "ms", "mx",

                // Academic & Professional
                "dr", "doctor", "prof", "professor", "phd", "eng", "esq", "esquire",

                // Nobility & Royalty
                "sir", "madam", "dame", "lord", "lady", "baron", "baroness",
                "count", "countess", "duke", "duchess", "earl", "viscount", "princess", "prince", "king", "queen",

                // Military & Service
                "capt", "captain", "col", "colonel", "maj", "major", "lt", "lieutenant",
                "cmdr", "commander", "sgt", "sergeant", "cpl", "corporal", "gen", "general", "adm", "admiral",

                // Religious
                "rev", "reverend", "fr", "father", "sis", "sister", "pastor", "imam", "imām",
                "rabbi", "sheikh", "shaykh", "mufti", "bishop", "archbishop", "pope", "cardinal",
                "brother", "elder", "pandit", "guru", "swami",

                // South & East Asian
                "sri", "shri", "smt", "ji", "babu", "rao", "devi", "kumari", "chan", "san", "kun", "sama", "sensei",

                // Honorary / Political
                "hon", "honorable", "rt", "rt.", "sen", "senator", "rep", "representative", "pres", "president", "gov", "governor", "amb", "ambassador",

                // Misc Cultural or Ceremonial
                "tunku", "tuan", "puan", "dato", "datuk", "tan", "tengku", "nguyen", "madame", "monsieur", "herr", "frau", "signor", "signora", "don", "doña"
            ]);
            if (/\\author(\[\w+\])?\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/gm.test(data)) {
                let res;
                while ((res = author.exec(data)) !== null) {
                    if (res) {
                        const names = res[res.length - 1]
                            .split(/\s+/)
                            .filter(word => {
                                const normalized = word.toLowerCase().replace(/\./g, ""); // remove dots before checking
                                return !honorifics.has(normalized);
                            })
                            .join(" ");

                        data = data.replace(res[res.length - 1], names);
                        return data;
                    }
                }
            }
        }
    },
    abstractfloatingobject: {
        name: "Remove floating from abstract",
        description: "Deletes floating objects like figures, tables ,textboxes etc from abstract block.",
        action: (data, fileName) => {
            let abstract = new RegExp(
                /\\begin{abstract}\n*(.*)?\n*\\end{abstract}/gms
            );
            const floatingObjects = new Set([/\\begin{table}\n*(.*)?\n*\\end{table}/gms, /\\begin{figure}\n*(.*)\n*\\end{figure}/gms, /\\begin{textboxes}\n*(.*)?\n*\\end{textboxes}/gms])
            if ((
                /\\begin{abstract}\n*(.*)?\n*\\end{abstract}/gms).test(data)) {
                data = data.replace(abstract, match => {
                    let cleaned = match;
                    // remove all floating objects within the abstract
                    for (const pattern of floatingObjects) {
                        cleaned = cleaned.replace(pattern, "");
                    }
                    return cleaned;
                });
                return data;
            }
        }
    },
    abstractformating: {
        name: "Abstract formatting",
        description: "Remove any new line or heading present in the abstract.",
        action: (data, fileName) => {
            let abstract = new RegExp(/\\begin{abstract}([\s\S]*?)\\end{abstract}/)
            if (abstract.test(data)) {
                // Extract and clean content
                data = data.replace(abstract, (match, content) => {
                    // Remove headings like \section, \subsection, etc.
                    content = content.replace(/\\(?:section|subsection|subsubsection)\*?{.*?}/g, "");

                    // Remove paragraph breaks (double newlines) and trim spaces
                    content = content.replace(/\n+/g, " ").replace(/\s{2,}/g, " ").trim();

                    return `\\begin{abstract}\n${content}\n\\end{abstract}`;
                });
            }

            return data;
        }
    },
    titlecasing: {
        name: "Title to caps",
        description: "Change the title to all caps",
        action: (data, fileName) => {
            // let title = new RegExp(/\\title\[(.*?)\]/gms)
            let title = new RegExp(/\\title(?:(\[[^\]]*\])?)(\{[^\}]*\})/gms)
            if (/\\title(?:\[[^\]]*\]?)(\{[^\}]*\})/gms.test(data)) {
                let res;
                while ((res = title.exec(data)) !== null) {
                    if (res) {
                        let titlecase = res[res.length - 1].toUpperCase();
                        console.log(res);
                        data = data.replace(res[0], `\\title${titlecase}`)
                    }
                }
                return data
            }
        }
    },
    keywordformatting: {
        name: "Keyword formatting",
        description: "The first keyword and proper noun starts with the capital letter, the rest is small case.",
        action: (data, fileName) => {
            const keywordsRegex = /\\keywords\s*{([^}]*)}/m;

            if (keywordsRegex.test(data)) {
                data = data.replace(keywordsRegex, (match, content) => {
                    // Split keywords and clean
                    let keywords = content.split(",").map(k => k.trim());

                    // Process each keyword
                    keywords = keywords.map((word, index) => {
                        // Analyze text using compromise
                        let doc = nlp(word);

                        // Capitalize proper nouns
                        doc.nouns().toTitleCase();

                        // Lowercase others, except the first keyword which should start capitalized
                        let text = doc.text();
                        if (index === 0) {
                            text = text.charAt(0).toUpperCase() + text.slice(1);
                        } else {
                            // For non-proper nouns: make sure non-title words are lowercase
                            text = text.replace(/\b(?![A-Z])[a-z]+\b/g, w => w.toLowerCase());
                        }
                        return text.trim();
                    });

                    return `\\keywords{${keywords.join(", ")}}`;
                });
            }

            return data;
        }
    },
    sectionHeading: {
        name: "Section heading casing",
        description: "Capitalize the first letter and for proper noun.",
        action: (data, fileName) => {
            let sectionTitle = new RegExp(/\\section\{(.*?)\}/gms);
            if (/\\section\{(.*?)\}/gms.test(data)) {
                let res;
                while ((res = sectionTitle.exec(data)) !== null) {
                    if (res) {
                        let text = res[res.length - 1];
                        // Uppercase the first character of the entire text
                        text = text.charAt(0).toUpperCase() + text.slice(1);

                        // Use compromise to find nouns
                        let doc = nlp(text);
                        let nouns = doc.nouns().out('array');

                        // Uppercase the first letter of each noun in the text
                        for (const noun of nouns) {
                            const regex = new RegExp(`\\b${noun}\\b`, 'gi');
                            text = text.replace(regex, match => {
                                return match.charAt(0).toUpperCase() + match.slice(1);
                            });
                        }

                        data = data.replace(res[0], `\\section{${text}}`)
                    }
                }
                return data
            }
        }
    },
    quotation: {
        name: "Replace quotation",
        description: "Replace all single quotes with double quotes.",
        action: (data, fileName) => {
            const quotesReg = new RegExp(/'/sm);
            let res;
            while ((res = quotesReg.exec(data)) !== null) {
                data = data.replace(res[0], `"`);
            }
            return data
        }
    },
    unitformat: {
        name: "Unit Formatting",
        description: "Provides a non-breaking space between a number and an unit",
        action: (data, fileName) => {
            const SIunit = new RegExp(/(\d+\$*\s?~*\.*)(m\.s|kg\.m|s|A|K|mol|cd|C|V|Ω|T|Wb|J|W|Pa|Hz|GHz|rad|sr|N|J|W|Wb|C|V|F|Ω|S|Wb|T|H|eV|u|Lx|lm|lx|Bq|Gy|Sv|kat|dB|kg|mm|m)(?!\w)/ms)
            let res;
            while ((res = SIunit.exec(data)) !== null) {
                data = data.replace(SIunit, (_, num, unit) => `${num}\u00A0\\mathrm{${unit}}`);
            }
            return data;
        }
    },
    latinPhrases: {
        name: "Latin Phrases italics",
        description: "Convert the latin phrases to italic format except etc which is converted to roman.",
        action: (data, fileName) => {
            const latinphrases = new RegExp(
                /\b(ad hoc|ad hominem|a posteriori|a priori|bona fide|carpe diem|de facto|de jure|exempli gratia|e\.g\.?|id est|i\.e\.?|in situ|in vitro|in vivo|ipso facto|mea culpa|modus operandi|per se|pro bono|quid pro quo|status quo|vice versa|ad infinitum|terra firma|curriculum vitae|alma mater|alter ego|deus ex machina|casus belli|et al\\.?|per annum|per capita|persona non grata|vox populi|post mortem|in medias res|tabula rasa|magnum opus|sic semper tyrannis|veni vidi vici|sub rosa)\b/gmsi);


            data = data.replace(latinphrases, match => `\\textit{${match}}`);

            data = data.replace(/\betc\.?\b/gi, `\\textup{etc.}`);
            return data;
        }
    },
    replacezerobefore: {
        name: "Include zero in fraction.",
        description: "Replace <<.5>> to <<0.5>>, include 0 before fractions if its missing.",
        action: (data, fileName) => {
            return data.replace(/(?<=\s|^)\.(\d+)/g, '0.$1');
        }
    },
    referenceplurals: {
        name: "Reference plurals",
        description: "Make all the citations reference as plural if it has more than one reference.",
        action: (data, fileName) => {

        }
    },
    hypentoendash: {
        name: "Hyphen to En Dash in Table",
        description: "Change hyphens to en dashes within the table.",
        action: (data, fileName) => {
            return data.replace(/\\begin{table}([\s\S]*?)\\end{table}/g, (match, tableContent) => {
                const updatedTable = tableContent.replace(/-/g, "--");
                return `\\begin{table}${updatedTable}\\end{table}`;
            });
        }
    },
    appendixtocapital: {
        name: "Appendix to sentence case",
        description: "Change the first letter of appendix text to capital",
        action: (data, fileName) => {
            return data.replace(/appendix/g, (match) => {
                return match.charAt(0).toUpperCase() + match.slice(1)
            })
        }
    },
    typographybasics: {
        name: "Basic typography",
        description: "Remove double space and space before and after punctuation.",
        action: (data, fileName) => {
            return data
                .replace(/\s{2,}/g, " ")
                .replace(/\s+([,.;:!?])/g, "$1")
                .replace(/([,.;:!?])\s{2,}/g, "$1 ")
                .replace(/\s+([\)\]\}”’])/g, "$1")
                .replace(/([\(\[\{“‘])\s+/g, "$1")
                .replace(/([a-zA-Z0-9\)\]])\s*$/gm, "$1.");
        }
    },
    listlevels: {
        name: "List Levelling",
        description: "Level lists safely with bullets, sentence casing after colon, punctuation.",
        action: (data, fileName) => {
            const listRegex = /\\begin{itemize}([\s\S]*?)\\end{itemize}/g;
            let outerMatch;

            // Collect all outer level lists
            while ((outerMatch = listRegex.exec(data)) !== null) {
                let block = outerMatch[1];

                // --- Level 1 ---
                block = block.replace(/(^|\n)\s*\\item\s+/g, '$1\\item[--] ');

                block = block.replace(/:\s*(\w)/g, (_, char) => `: ${char.toUpperCase()}`);

                // Replace semicolons, normalize spacing
                block = block.replace(/;\s*(?=\S)/g, '; ');
                // Ensure last item ends with full stop
                block = block.replace(/([^;]+)$/, (match) => match.trim().endsWith('.') ? match : match.trim() + '.');

                // --- Level 2 ---
                block = block.replace(/\\begin{itemize}([\s\S]*?)\\end{itemize}/g, (m) => {
                    let inner = m;
                    inner = inner.replace(/(^|\n)\s*\\item\s+/g, '$1\\item[\\textbullet] ');

                    // Sentence casing after colon
                    inner = inner.replace(/:\s*(\w)/g, (_, char) => `: ${char.toUpperCase()}`);
                    // Comma separation + full stop
                    inner = inner.replace(/([^,]+)(,|$)/g, (_, item, sep) => item.trim() + (sep ? ',' : '.'));

                    return inner;
                });

                // --- Level 3 ---
                block = block.replace(/(\\begin{itemize}[\s\S]*?\\begin{itemize})([\s\S]*?)(\\end{itemize}[\s\S]*?\\end{itemize})/g, (m) => {
                    let inner = m.replace(/(^|\n)\s*\\item\s+/g, '$1\\item[\\(\\circ\\)] ');

                    inner = inner.replace(/:\s*(\w)/g, (_, char) => `: ${char.toUpperCase()}`);
                    inner = inner.replace(/([^,]+)(,|$)/g, (_, item, sep) => item.trim() + (sep ? ',' : '.'));

                    return inner;
                });

                // --- Replace outer block ---
                data = data.slice(0, outerMatch.index) + `\\begin{itemize}${block}\\end{itemize}` + data.slice(outerMatch.index + outerMatch[0].length);
            }

            return data;
        }
    },
    statementplacement: {
        name: "Statement Placement",
        description: "Place the statement values before reference and after acknowledgement and arrange them as per requirement.",
        action: (data, fileName) => {
            // const statementRegex = new RegExp(/(\\textcolor\{[^\}]*})?\{\\section\*?\{(Data\s*Availability\s*Statement|Conflict\s*of\s*Interest|Funding|Author\s*contribution\s*statement|Ethics\s*approval|Supplementary\s*material)\}[\s\S]*?(?=\\section|\%*\\begin?\{thebibliography|bibliography\}|\\textcolor{[^\}]*}\{?\\section)/gmsi)
            const ackRegex = new RegExp(/\\section\*?\{Acknowledgment\}[\s\S]*?(?=\\textcolor|\\section)/igms);
            const refRegex = new RegExp(/\\begin\{(thebibliography|bibliography)\}(\{\d+\})*/igms)
            const statementRegex = /(\\textcolor\{[^\}]*})?\{\\section\*?\{([^}]+)\}([\s\S]*?)(?=\\section|%*\\begin?\{thebibliography|bibliography\}|\\textcolor\{[^\}]*}\{?\\section)/gmsi;

            const order = [
                "Funding",
                "Conflicts of interest",
                "Data availability statement",
                "Author contribution statement",
                "Ethics approval",
                "Supplementary Material"
            ];

            // Collect all matched statements in a map
            const statementsMap = {};
            data = data.replace(statementRegex, (match, _color, title, content) => {
                const key = title.trim().toLowerCase();
                statementsMap[key] = content.trim();
                return ""; // remove from original location
            });

            // Build the statements block in the specified order
            const statementsBlock = order
                .map(title => {
                    const key = title.toLowerCase();
                    if (statementsMap[key]) {
                        return `\\section*{\\textbf{${title}}}\n${statementsMap[key]}`;
                    }
                    return null;
                })
                .filter(Boolean)
                .join("\n\n");

            if (!statementsBlock) return data; // nothing to insert

            // Collect all statement matches and remove them from original data
            const ackMatch = data.match(ackRegex);
            const refMatch = data.match(refRegex);

            // Determine insertion point
            if (ackMatch && refMatch) {
                const ackEndIndex = data.indexOf(ackMatch[0]) + ackMatch[0].length;
                data = data.slice(0, ackEndIndex) + "\n\n" + statementsBlock + "\n\n" + data.slice(ackEndIndex);
            } else if (ackMatch) {
                const ackEndIndex = data.indexOf(ackMatch[0]) + ackMatch[0].length;
                data = data.slice(0, ackEndIndex) + "\n\n" + statementsBlock + "\n\n" + data.slice(ackEndIndex);
            } else if (refMatch) {
                const refStartIndex = data.indexOf(refMatch[0]);
                data = data.slice(0, refStartIndex) + "\n\n" + statementsBlock + "\n\n" + data.slice(refStartIndex);
            } else {
                data += "\n\n" + statementsBlock;
            }

            return data;
        }
    },
    checkcitationinlist: {
        name: "Citation in reference check",
        description: "Check's whether the citations present in the text are present in the list of reference.",
        action: (data, fileName, toast) => {
            const citeRegex = /\\cite\{([^\}]*)\}/gms;
            const refRegex = /\\bibitem\{([^\}]*)\}/gms;

            const citationlist = new Set();
            const reflist = new Set();
            let res;

            // Collect all citations
            while ((res = citeRegex.exec(data)) !== null) {
                res[1].split(",").map(item => citationlist.add(item.trim()));
            }

            // Collect all references
            while ((res = refRegex.exec(data)) !== null) {
                reflist.add(res[1].trim());
            }

            const missingInRef = Array.from(citationlist).filter(cite => !reflist.has(cite));
            const notCited = Array.from(reflist).filter(ref => !citationlist.has(ref));

            if (missingInRef.length > 0) {
                toast({
                    title: `Citations missing in reference list:`,
                    description: (
                        <>
                            {missingInRef.map((item, idx) => (
                                <div key={idx}>{item}</div>
                            ))}
                        </>
                    ),
                    status: "info",
                    duration: null,
                    isClosable: true,
                })

            }

            if (notCited.length > 0) {
                console.warn("References not cited in text:", notCited);
                toast({
                    title: `References not cited in text:`,
                    description: (
                        <>
                            {notCited.map((item, idx) => (
                                <div key={idx}>{item}</div>
                            ))}
                        </>
                    ),
                    status: "info",
                    duration: null,
                    isClosable: true,
                })
            }

            if (missingInRef.length === 0 && notCited.length === 0) {
                console.log("All citations match references perfectly.");
                toast({
                    title: `All citations match references perfectly.`,
                    description: "",
                    status: "info",
                    duration: 1000,
                    isClosable: true,
                })
            }

            return data;
        }
    },
    removeverticallinesintable: {
        name: "Remove table vertical lines.",
        description: "Removes vertical lines in tables from column definition",
        action: (data, fileName) => {
            data = data.replace(/\\begin\{tabular\}\{([^\}]*)\}/g, (match, columns) => {
                // Remove all vertical bars
                const cleanColumns = columns.replace(/\|/g, '');
                return `\\begin{tabular}{${cleanColumns}}`;
            });
            return data;
        }
    },
    orderCheck: {
        name: "Section Order Enforcement",
        description: "Ensures the correct order: Acknowledgments → Statements → References → Citation box → Appendices.",
        action: (data, fileName) => {
            // Regex patterns for each section
            const ack = /\\section\*?\{Acknowledg?ments?\}[\s\S]*?(?=(\\section|\%*\\begin\{thebibliography\}|\\bibliography|\\appendix|$))/i;
            const statements = /(\\textcolor\{[^\}]*}\{)?\\section\*?\{(Data\s*Availability|Funding|Conflict|Author|Ethics|Supplementary)[\s\S]*?(?=(\\section|\%*\\begin\{thebibliography\}|\\bibliography|\\appendix|$))/gi;
            const references = /(\\begin\{thebibliography\}[\s\S]*?\\end\{thebibliography\})|(\\bibliography\{[^\}]*\})/i;
            const citationBox = /\\begin\{citationbox\}[\s\S]*?\\end\{citationbox\}/i;
            const appendices = /(\\appendix|\\section\*?\{Appendix[^\}]*\})[\s\S]*/i;

            // Extract existing matches
            const sections = {
                ack: data.match(ack)?.[0] || "",
                statements: (data.match(statements) || []).join("\n"),
                references: data.match(references)?.[0] || "",
                citationBox: data.match(citationBox)?.[0] || "",
                appendices: data.match(appendices)?.[0] || ""
            };

            // Build the correct order
            const orderedDoc = [
                sections.ack,
                sections.statements,
                sections.references,
                sections.citationBox,
                sections.appendices
            ].filter(Boolean).join("\n\n");

            // Remove the old occurrences before reinserting
            data = data
                .replace(ack, "")
                .replace(statements, "")
                .replace(references, "")
                .replace(citationBox, "")
                .replace(appendices, "");

            // Reinsert the properly ordered version at the end
            data += "\n" + orderedDoc;

            return data;
        }
    },
    referenceformatter: {
        name: "Reference Cleanup and Formatting",
        description: "Validates and formats the reference section with consistent structure and typography.",
        action: (data, fileName) => {
            const bibregex = /\\bibitem\{([^\}]*)\}([\p{L}\d\.\s\-\\']+(?:,\s*[\p{L}\d\.\s\-\\']+)*(?:\s+and\s*[\p{L}\d\.\s\-\\']*)?),(\n*.*?(?=\n*))\n([\\textit]*\{[^\}]*\})*\s*([\\textbf]*\{\d+\})*(?:\s*\((\d+)\)(?=\s*\(\d{4}\)))?(?:\s*\(?(\d{4})\)?)?\s*(\w*\d+(?:--\w*\d+)?)?/gmu

            let formattedData = data;
            let res;

            while ((res = bibregex.exec(data)) !== null) {
                let [fullMatch, key, authors, title, journal, volume, issue, year, pages] = res;

                // Track missing elements
                let missing = [];
                if (!authors) missing.push("authors");
                if (!title) missing.push("title");
                if (!journal) missing.push("journal");
                if (!volume) missing.push("volume");
                if (!year) missing.push("year");
                if (!pages) missing.push("pages");

                // 1. Title: Roman (LaTeX default), remove any existing \textit{}
                if (title) {
                    title = title.trim().replace(/\\textit\{([^\}]*)\}/g, "$1");
                }

                // 2. Journal: Italics, abbreviated, capitalize first word, avoid double \textit{}
                if (journal) {
                    journal = journal.trim().replace(/^\\textit\{([^\}]*)\}$/g, "$1"); // unwrap if already wrapped
                    journal = journal.replace(/^(.)/, (c) => c.toUpperCase());
                    journal = `\\textit{${journal}}`;
                } else {
                    journal = '';
                }

                // 3. Volume: Bold, avoid double \textbf{}
                if (volume) {
                    volume = volume.trim().replace(/^\\textbf\{([^\}]*)\}$/g, "$1");
                    volume = `\\textbf{${volume}}`;
                }

                // 4. Year: parentheses
                if (year) {
                    year = year.trim();
                    if (!/^\(.*\)/.test(year)) {
                        year = `(${year})`;
                    }
                }

                // 5. Pages: double dash
                if (pages) {
                    pages = pages.replace(/(?<!-)-/g, '--');
                }

                // console.log(`key : ${key && key} \n Authors: ${authors ? authors : "Not found"} \n Title: ${title ? title : "title not found"} \n Journal : ${journal ? journal : "Journal not found."}\n Volume: ${volume ? volume : 'volume not found'}\n Year: ${year ? year : "year not found."}\n Pages: ${pages ? pages : "pages not found."}`);


                // 6. Combine formatted reference
                let formattedRef = `\\bibitem{${key}}${authors ? authors + ',\n' : ''}${title ? title + '\n' : ''}${journal ? journal + ' ' : ''}${volume ? volume + ' ' : ''}${year ? year + ' ' : ''}${pages ? pages : ''}\n ${missing.length ? `\\AQ{Missing elements: ${missing.join(",")} }` : ""}`;

                // Replace the old reference
                formattedData = formattedData.replace(fullMatch, formattedRef);
            }

            return formattedData;
        }
    },
    uncitedReferences: {
        name: "Uncited References",
        description: "Captures the references which are not cited in the body and place it under the article under heading uncited references, And if the cited reference is not present in the reference list query is raised to the author.",
        action: (data, fileName) => {
            const refKey = new RegExp(/\\bibitem\{([^\}]*)\}(\n*.*?)(?=\\bibitem|\\end\{thebibliography\})/gmsu)
            const refcite = new RegExp(/\\cite\{([^\}]*)\}/gum);
            let ref;
            let cite = new Set();
            let referencekey = [];
            let noncited = [];
            while ((ref = refcite.exec(data)) !== null) {
                ref[ref.length - 1].split(",").map((i) => cite.add(i));
            }
            while ((ref = refKey.exec(data)) !== null) {
                if (!Array.from(cite).includes(ref[1])) {
                    noncited.push(ref[0])
                }
                referencekey.push(ref[1]);
            }

            cite.forEach((c) => {
                if (!referencekey.includes(c)) {
                    const citeRegex = new RegExp(`\\\\cite\\{(?:,*[^}]*)?${c}(?:,[^}]*)?\\}`, 'g');
                    data = data.replace(citeRegex, (match) => {
                        return `${match} \\AQ{Reference is missing for the citation ${c}.}`
                    });
                    console.log(c);

                }
            })
            if (noncited.length) {
                data = data.replace(/\\end\{document\}/, "\\title{Uncited References} \n\n" + noncited.join("\n\n") + "\n" + "\\end{document}")
            }
            return data;
        }
    },
    mathToRoman: {
        name: "Math functions to Roman",
        description: "Convert math function like sin, cos , tan etc to roman.",
        action: (data, fileName) => {
            const functions = ["cos", "sin", "tan", "exp", "log", "lim", "Tr", "det"];
            const funcRegex = new RegExp(`\\b(${functions.join("|")})\\b`, "g");

            // Match everything inside \begin{equation}...\end{equation}
            const equationRegex = /\\begin\{equation\}([\s\S]*?)\\end\{equation\}/g;

            return data.replace(equationRegex, (match, equationContent) => {
                const updatedEquation = equationContent.replace(funcRegex, (fn) => `\\mathrm{${fn}}`);
                return `\\begin{equation}${updatedEquation}\\end{equation}`;
            });
        }
    },
    energyToRoman: {
        name: "Energy level to Roman",
        description: "Convert the energy level occurances inside the document into roman.",
        action: (data, fileName) => {
            const energyRegex = /\b\d+[A-Z]\d*[a-z]?\b/g;
            return data?.replace(energyRegex, (match) => `\\mathrm{${match}}`);
        }
    },
    spacing: {
        name: "Provide spacing",
        description: "Provides spacing to various elements with respect to their condition in the table provided in rule sheet.",
        action: (data, fileName, toast) => {
            if (data) {
                let out = data;

                // 1. Degrees: space before = no, space after = yes
                //   30° -> 30° 
                //   30°A (degree followed by letter/symbol) -> space before yes, after no
                out = out.replace(/(\d)\s*°\s*(?=[A-Za-z])/g, "$1 °");
                out = out.replace(/(\d)\s*°/g, "$1° ");

                // 2. Minutes (′) and seconds (″): no space before, space after yes
                out = out.replace(/(\d)\s*′/g, "$1′ ");
                out = out.replace(/(\d)\s*″/g, "$1″ ");

                // 3. Ampersand: space before yes, space after yes
                out = out.replace(/\s*&\s*/g, " & ");

                // 4. Fractions in addresses: "12/4" → space before yes, space after no
                // Only if it's number/number
                out = out.replace(/(\d)\s*\/\s*(\d)/g, " $1/$2");

                // 5. Ordinal numbers: no space before, space after yes
                // 1st, 2nd, 3rd, 4th
                out = out.replace(/(\d)(st|nd|rd|th)(?!\w)/g, "$1$2 ");

                // 6. Arithmetic signs: +, -, ×, ÷ -> space before yes, after yes
                // Arithmetic signs ONLY between numbers: space before yes, after yes
                out = out.replace(/(\d)\s*([+\-×÷])\s*(\d)/g, " $1 $2 $3 ");

                // 7. Percentage: space before no, space after yes
                out = out.replace(/(\d)\s*%/g, "$1% ");

                // 8. SI units: space before yes, space after yes
                // shortlist of common SI units (extend as needed)
                const si = ["m", "cm", "mm", "kg", "g", "s", "A", "K", "mol", "cd", "N", "J", "W", "Pa", "V", "Hz"];
                const siRegex = new RegExp(`(\\d)\\s*(${si.join("|")})(?!\\.)\\b`, "g");
                out = out.replace(siRegex, "$1 $2 ");

                // 9. Currency units: no space before, space after yes
                // $, ₹, €, £
                out = out.replace(/\s*([$₹€£])\s*(\d)/g, "$1$2 ");

                return out;
            } else {
                toast({
                    title: `No data passed, please check the document`,
                    description: "",
                    status: "info",
                    duration: 1000,
                    isClosable: true,
                })
            }
        }
    },
    figtoPlural: {
        name: "Fig to Plural",
        description: "If there are more than one figure ref present inside the reference then convert it to plural.",
        action: (data, fileName) => {
            return data?.replace(/\\figref\{([^}]*)\}/g, (match, inside) => {
                // Clean spaces around commas and dashes
                let cleaned = inside.replace(/\s*,\s*/g, ",").replace(/\s*-\s*/g, "-");

                // Split by comma or by dash-range
                let parts = cleaned.split(",");

                // Count figure references
                let count = 0;
                parts.forEach(p => {
                    if (p.includes("-")) {
                        // Range like fig1-fig4
                        let [start, end] = p.split("-");
                        if (start && end) count += 2;  // treat as plural
                    } else {
                        count++;
                    }
                });

                // If more than one figure → plural prefix
                if (count > 1) {
                    // Ensure figs: prefix
                    let updated = cleaned.replace(/^([fig|figure]*)/, "$1s");
                    return `\\figref{${updated}}`;
                }

                return match;
            });
        }
    },
    citeinfigure: {
        name: "Citation in figure",
        description: "Citation present in the figure but not anywhere in the text.",
        action: (data, fileName) => {

            // Collect all citations in the document
            const citeRegex = /\\cite\{([^}]*)\}/g;
            let match;
            const allCites = [];
            while ((match = citeRegex.exec(data)) !== null) {
                match[1].split(",").map(c => allCites.push(c.trim()));
            }

            // Match figure environments
            const figureRegex = /\\begin\{figure\}([\s\S]*?)\\end\{figure\}/g;

            return data.replace(figureRegex, (fullFigureMatch) => {
                // Replace only caption inside the figure
                return fullFigureMatch.replace(/\\caption\{((?:[^{}]*(?:{(?:[^{}]*(?:{(?:[^{}]*(?:{[^{}]*})*[^{}]*)*})*[^{}]*)*})*[^{}]*)*)\}/g, (capMatch, capContent) => {
                    const updatedCaption = capContent.replace(citeRegex, (fullCiteMatch, citeKeys) => {
                        let noofCite;

                        const keys = citeKeys.split(",").map(k => k.trim());
                        const newKeys = keys.map(k => {
                            // Count total occurrences of this key in document
                            const occurrences = (data.match(new RegExp(`\\\\cite\\{[^}]*\\b${k}\\b[^}]*\\}`, "g")) || []);
                            // If it occurs only once (inside this caption), wrap with \AQ{}
                            noofCite = occurrences.length
                            return occurrences;
                        });

                        return noofCite === 1 ? `${newKeys} \\AQ{The reference is not cited in the text.}` : `\\cite{${newKeys.join(", ")}}`;
                    });

                    return `\\caption{${updatedCaption}}`;
                });
            });
        }
    },
    checkfigureforlegend: {
        name: "Figure legend check",
        description: "Checks to see whether the figure has legend present in it.",
        action: (data, fileName, toast) => {
            const figureRegex = /\\begin\{figure\}([\s\S]*?)\\end\{figure\}/g;

            let missing = [];
            let match;

            while ((match = figureRegex.exec(data)) !== null) {
                const figureBlock = match[0];

                // Simple caption check
                const hasCaption = /\\caption\{[\s\S]*?\}/.test(figureBlock);

                if (!hasCaption) {
                    missing.push(figureBlock);
                }
            }
            if (missing.length > 0) {
                toast({
                    title: `legend missing in the figure tag`,
                    description: (
                        <>
                            {missing.map((item, idx) => (
                                <div key={idx}>{item}</div>
                            ))}
                        </>
                    ),
                    status: "info",
                    duration: null,
                    isClosable: true,
                })
            }
        }

    },
    citationinabstract: {
        name: "Citation in Abstact",
        description: "Check to see if there is any citation present in the abstract, replace the cite with its title.",
        action: (data, fileName, toast) => {
            // Abstract block
            const abstractRegex = /\\begin\{abstract\}([\s\S]*?)\\end\{abstract\}/m;

            const absMatch = abstractRegex.exec(data);
            if (!absMatch) return data; // no abstract, no drama

            let abstractContent = absMatch[1];

            // Citations inside the abstract
            const citeRegex = /\\cite\{([^}]+)\}/g;

            // Your bib regex from hell
            const bibregex = /\\bibitem\{([^\}]*)\}([\p{L}\d\.\s\-\\']+(?:,\s*[\p{L}\d\.\s\-\\']+)*(?:\s+and\s*[\p{L}\d\.\s\-\\']*)?),(\n*.*?(?=\n*))\n([\\textit]*\{[^\}]*\})*\s*([\\textbf]*\{\d+\})*(?:\s*\((\d+)\)(?=\s*\(\d{4}\)))?(?:\s*\(?(\d{4})\)?)?\s*(\w*\d+(?:--\w*\d+)?)?/gmu;

            // Build map: citeKey -> title
            const titleMap = {};
            let bm;
            while ((bm = bibregex.exec(data)) !== null) {
                const key = bm[1];        // cite key
                const title = bm[3]?.trim();  // title-ish group (your third capture)
                if (key && title) {
                    titleMap[key] = title;
                }
            }

            // The rest of the doc (for checking presence outside abstract)
            const before = data.slice(0, absMatch.index);
            const after = data.slice(absMatch.index + absMatch[0].length);
            const outsideText = before + after;

            // For reporting missing citations
            const missingFromText = new Set();

            // Replace citations inside abstract
            abstractContent = abstractContent.replace(citeRegex, (full, keys) => {
                const list = keys.split(",").map(k => k.trim());
                const titles = list.map(k => titleMap[k] || k); // fallback to key
                return titles.join("; "); // or comma, whatever you want
            });

            let c;
            const abstractScanner = citeRegex;
            abstractScanner.lastIndex = 0;

            while ((c = abstractScanner.exec(abstractContent)) !== null) {
                const keyList = c[1].split(",").map(k => k.trim());
                keyList.forEach(k => {
                    const pattern = new RegExp(`\\\\cite\\{[^}]*\\b${k}\\b[^}]*\\}`, "g");
                    const foundOutside = pattern.test(outsideText);

                    if (!foundOutside) {
                        missingFromText.add(k);
                    }
                });
            }

            if (missingFromText.size > 0) {
                console.log(missingFromText);

                toast({
                    title: `legend missing in the figure tag`,
                    description: (
                        <>
                            {missingFromText.map((item, idx) => (
                                <div key={idx}>{item}</div>
                            ))}
                        </>
                    ),
                    status: "info",
                    duration: null,
                    isClosable: true,
                })
            }

            // Reinsert updated abstract
            return data.replace(abstractRegex, `\\begin{abstract}${abstractContent}\\end{abstract}`);
        }
    }
}


export default style    